// extracted by mini-css-extract-plugin
export default {"root":"Rk5tc_Rk5tc","link":"ju98T_ju98T","right":"aOPci_aOPci","language":"bJl4O_bJl4O","copyright":"breX2_breX2","help":"rVqRn_rVqRn"};